(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("rxjs/Rx"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "rxjs/Rx"], factory);
	else if(typeof exports === 'object')
		exports["blade-ng-lib"] = factory(require("@angular/core"), require("rxjs/Rx"));
	else
		root["blade-ng-lib"] = factory(root["ng"]["core"], root["Rx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_7__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition